import React from 'react'

const Navbar = () => {
  return (
    <nav>
    <h1><u>Expense Manager</u></h1>
</nav>
  )
}

export default Navbar
